import { useTranslation } from "react-i18next";

import ProgressionModal from "../../../theme/ProgressionBuilder/ProgressionModal";
import ProgressionWrapper from "../../../theme/ProgressionBuilder/ProgressionWrapper";
import { useCreateOrderMutation } from "../../../../newapi/order/ordersSlice";
import Details from "./views/Details";
import AddressDetails from "./views/AddressDetails";
import ShipperDetails from "./views/ShipperDetails";

const MpCreateStandaloneShipment = (props) => {
    const {t} = useTranslation();

    const onSave = () => {
        props.handleClose();
    }

    return (
        <ProgressionModal
            open={props.open}
            onClose={props.handleClose}
        >
            <ProgressionWrapper 
                onSave={onSave} 
                // query={useCreateOrderMutation} 
                isModal 
                title={t("create_standalone_shipment")}
            >
                <Details/>
                <AddressDetails/>
                <ShipperDetails/>
            </ProgressionWrapper>
        </ProgressionModal>
    )
}

export default MpCreateStandaloneShipment;